import React from 'react';
import { TripDetailProps } from 'src/common/api/response';
import { Container } from 'src/components/bases';
import { BoardingContent } from './BoardingContent';
import { GalleryContent } from './GalleryContent';
import { ReviewContent } from './ReviewContent';
import { TabBar } from './TabBar';

const DummyTabs = ['tripDetails', 'review', 'gallery'];

export const TripDetailBody = ({
  tripDetailInfo,
  // paddingTop = metrics.large,
  onCloseModal,
}: {
  tripDetailInfo?: TripDetailProps;
  // paddingTop?: number;
  onCloseModal?: () => void;
}) => {
  const [selectedIndex, setSelectedIndex] = React.useState<number>(0);

  const renderBody = (index: number) => {
    switch (index) {
      case 0:
        if (tripDetailInfo) return <BoardingContent onCloseModal={onCloseModal} tripDetail={tripDetailInfo} />;
        break;
      case 1:
        if (tripDetailInfo) return <ReviewContent trip={tripDetailInfo} />;
        break;
      default:
        if (tripDetailInfo) return <GalleryContent tripId={tripDetailInfo.tripId} />;
    }
    return null;
  };

  return (
    // <ScrollView
    //   contentContainerStyle={{ paddingTop, paddingBottom: metrics.large }}
    //   style={{ flex: 1, width: '100%' }}
    //   scrollEventThrottle={400}
    //   onScroll={({ nativeEvent }) => {
    //     if (isCloseToBottom(nativeEvent)) {
    //       handleFetchMore();
    //     }
    //   }}>
    <TabBar
      tabs={DummyTabs}
      renderBody={index => <Container flex>{renderBody(index)}</Container>}
      value={selectedIndex}
      onChange={setSelectedIndex}
    />
    // </ScrollView>
  );
};
